import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import { compose, setDisplayName } from "recompose";
import NextForm from "../containers/NextForm";

export const ScooterForm = props => {
  const {
    currentScooter,
    onSubmit,
    submittingScooter,
    failSubmitScooter,
    initialValues,
    inputs,
    focusNextField
  } = props;
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validate}
      render={props => (
        <Form>
          {failSubmitScooter && (
            <Alert color="danger">{failSubmitScooter}</Alert>
          )}
          <Field
            innerRef={input => (inputs.vin = input)}
            onKeyPress={focusNextField("license_plate")}
            name="vin"
            component={TextInput}
            label="VIN"
            placeholder="Scooter VIN"
          />
          <Field
            innerRef={input => (inputs.license_plate = input)}
            onKeyPress={focusNextField("brand")}
            name="license_plate"
            component={TextInput}
            label="License Plate"
            placeholder="Scooter License Plate"
          />
          <Field
            innerRef={input => (inputs.brand = input)}
            onKeyPress={focusNextField("model")}
            name="brand"
            component={TextInput}
            label="Brand"
            placeholder="Scooter Brand"
          />
          <Field
            innerRef={input => (inputs.model = input)}
            onKeyPress={focusNextField("year")}
            name="model"
            component={TextInput}
            label="Model"
            placeholder="Scooter Model"
          />
          <Field
            innerRef={input => (inputs.year = input)}
            onKeyPress={focusNextField("color")}
            name="year"
            type="number"
            component={TextInput}
            label="Year"
            placeholder="Scooter Year"
          />
          <Field
            innerRef={input => (inputs.color = input)}
            name="color"
            component={TextInput}
            label="Color"
            placeholder="Scooter Color"
          />
          <Button
            fill
            type="submit"
            disabled={submittingScooter}
            color="primary"
          >
            {currentScooter ? "Update" : "Create"} Scooter{" "}
            <FontAwesomeIcon icon={currentScooter ? faEdit : faPlus} />
          </Button>
        </Form>
      )}
    />
  );
};

ScooterForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  submittingScooter: PropTypes.bool.isRequired,
  failSubmitScooter: PropTypes.string
};

export const validate = (values = {}) => {
  const errors = {};
  if (!values.vin) {
    errors.vin = "Required";
  }
  if (!values.brand) {
    errors.brand = "Required";
  }
  if (!values.license_plate) {
    errors.license_plate = "Required";
  }
  if (!values.model) {
    errors.model = "Required";
  }
  if (!values.color) {
    errors.color = "Required";
  }
  if (!values.year) {
    errors.year = "Required";
  } else if (!/^\d{4}$/.test(values.year)) {
    errors.year = "Invalid year number";
  }
  return errors;
};

export default compose(
  setDisplayName("ScooterForm"),
  NextForm
)(ScooterForm);
